import React from 'react';
import { useOidcAccessToken } from '@axa-fr/react-oidc';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

export default function UserValidate(props = { children: {} }) {
  const theRequiredPermission = 'CDPP:ADM';
  const { accessTokenPayload } = useOidcAccessToken();
  let allowed = false;
  if (accessTokenPayload.permissions) {
    if (Array.isArray(accessTokenPayload.permissions)) {
      allowed = accessTokenPayload.permissions.find((p) => p === theRequiredPermission);
    } else {
      allowed = accessTokenPayload.permissions === theRequiredPermission;
    }
  }
  return (
    <>
      {
        // eslint-disable-next-line react/prop-types,react/jsx-no-useless-fragment
        allowed && (<>{props?.children}</>)
      }
      {
        // eslint-disable-next-line react/no-unescaped-entities
        !allowed && (<div style={{ height: 'calc(100vh - 200px)', paddingTop: '50px' }}>
          <h1 className="mt-5 text-center mb-3 text-danger">
            <FontAwesomeIcon icon={faLock} className="me-1" /> Forbidden</h1>
          <h3 className="text-center text-muted">
            {`You don't have the permission to access this page.`}
          </h3>
        </div>)
      }
    </>
  );
}
